import { merge } from '@/helpers/Utility';
import { secondsToTimeString } from '@/helpers/dateHelper';
import { strings } from '@/services/translation/strings';
import { FC } from 'react';

interface PatternFallbackCellProps {
  patternStart?: number;
  patternEnd?: number;
  hoverOnly?: boolean;
}

export const MyCalendarPatternFallbackCell: FC<PatternFallbackCellProps> = ({
  patternStart,
  patternEnd,
  hoverOnly
}) => {
  const start = patternStart ? secondsToTimeString(patternStart) : strings.common.na;
  const end = patternEnd ? secondsToTimeString(patternEnd) : strings.common.na;

  return (
    <div
      className={merge(
        'relative h-full w-full flex items-center justify-center',
        hoverOnly ? 'opacity-0 hover:opacity-100' : ''
      )}
    >
      <div className="w-14 h-14 rounded-md flex flex-col items-center justify-center">
        <span>
          {start} - {end}
        </span>
      </div>
    </div>
  );
};
